import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import BannerNoticias from "../noticias/BannerNoticias";
import ListadoRepuestos from "../liquidacionRepuestos/ListadoRepuestos";
const Footer = lazy(() => import('../footer/Footer'));
function Noticias() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Ponte al día con Hyundai. Revisa las noticias relevantes de nuestra marca, no te pierdas de ninguna"
        />
        <meta name="keywords" content="Hyundai, noticias, actualidad" />
        <title>Noticias Hyundai</title>
      </Helmet>
      <Menu />
      <BannerNoticias />
      <ListadoRepuestos />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Noticias;